<div class="cm-msg" [class.mine]="mine" [class.poll]="isPoll" [class.grouped]="grouped" [class.picker-open]="emojiOpen">
  <ng-container *ngIf="!mine">
    <span class="cm-av" *ngIf="!grouped" aria-hidden="true">
      <img *ngIf="showAvatarPhoto; else ini" [src]="sender.profileUrl" alt="" />
      <ng-template #ini>{{ sender.shortName }}</ng-template>
    </span>
    <span class="cm-av-gap" *ngIf="grouped"></span>
  </ng-container>

  <div class="cm-body">
    <div class="cm-who" *ngIf="!grouped && !mine">
      <b>{{ sender.nickname }}</b><time>{{ time }}</time><span class="cm-edited" *ngIf="message?.editedAt">edited</span>
    </div>

    <div class="cm-content" [class.cm-bubble]="mine && !isPoll">
      <ng-container *ngIf="!blocked; else blockedTpl">
        <ng-container *ngIf="!editing; else editTpl">
          <pre class="cm-txt" *ngIf="message?.message" [class.clamp]="isLong && !message.isExpanded">{{ message.message }}</pre>
          <span class="cm-edited" *ngIf="message?.editedAt && grouped && !mine">(edited)</span>
        </ng-container>
        <ng-template #editTpl>
          <div class="cm-edit">
            <textarea #editBox class="cm-edit-box" rows="2" aria-label="Edit message" [(ngModel)]="draft" (keydown)="onEditKey($event)"></textarea>
            <div class="cm-edit-bar">
              <span>Esc to cancel · Enter to save</span>
              <button type="button" (click)="cancelEdit()">Cancel</button>
              <button type="button" class="cm-save" (click)="saveEdit()">Save</button>
            </div>
          </div>
        </ng-template>
        <app-cm-poll *ngIf="message?.type === 'poll'" [poll]="message" [currentUserId]="currentUserId"
          [canVote]="canVote" (vote)="vote.emit($event)"></app-cm-poll>

        <div class="cm-files" *ngIf="message?.files?.length">
          <ng-container *ngFor="let file of message.files">
            <button *ngIf="file.type === 'image'" type="button" class="cm-img" (click)="openImage.emit(file.url)"
              title="Open preview">
              <img [src]="file.url" alt="Image attachment" />
            </button>
            <video *ngIf="file.type === 'video'" controls class="cm-media"><source [src]="file.url" type="video/mp4"></video>
            <audio *ngIf="file.type === 'audio'" controls class="cm-audio"><source [src]="file.url" type="audio/mpeg"></audio>
            <div *ngIf="file.type === 'document'" class="cm-doc">
              <i class="fa fa-file-text" aria-hidden="true"></i>
              <span class="cm-doc-name" [title]="file.name">{{ file.name }}</span>
              <button type="button" class="cm-icon" (click)="download.emit(file)" [attr.aria-label]="'Download ' + file.name">
                <mat-icon>download</mat-icon>
              </button>
            </div>
          </ng-container>
        </div>

        <button type="button" class="cm-more" *ngIf="isLong" (click)="toggleExpand.emit()">
          {{ message.isExpanded ? 'Show less' : 'Show more' }}
        </button>
      </ng-container>
      <ng-template #blockedTpl>
        <span class="cm-blocked"><app-svg [icon]="'community_block_icon'"></app-svg> This message has been blocked</span>
      </ng-template>
      <time class="cm-mine-time" [class.cm-under]="isPoll" *ngIf="mine">{{ time }}<ng-container *ngIf="message?.editedAt"> · edited</ng-container></time>
    </div>

    <div class="cm-reacts" *ngIf="reactionKeys.length || (replyCount && !isThread)">
      <ng-container *ngFor="let emoji of reactionKeys">
        <button type="button" class="cm-chip" [class.me]="reactedByMe(emoji)" (click)="react.emit(emoji)"
          (mouseenter)="reactionEnter.emit({ emoji: emoji, trigger: trig })" (mouseleave)="reactionLeave.emit(trig)"
          [attr.aria-label]="emoji + ' ' + message.reactions[emoji]?.count">
          {{ emoji }} {{ message.reactions[emoji]?.count }}
        </button>
        <!-- hover-only anchor for the "who reacted" list, so a click on the chip only toggles the reaction -->
        <span class="cm-anchor" #trig="matMenuTrigger" [matMenuTriggerFor]="whoMenu"></span>
        <mat-menu #whoMenu="matMenu" class="cm-menu">
          <div class="cm-who-row" *ngFor="let user of reactionUsers">
            <span class="cm-av sm">
              <img *ngIf="user.profileUrl; else uini" [src]="user.profileUrl" alt="" />
              <ng-template #uini>{{ user.shortName }}</ng-template>
            </span>
            <span>{{ shortName(user.nickname) }}</span><span class="cm-who-emoji">{{ hoveredReaction }}</span>
          </div>
        </mat-menu>
      </ng-container>
      <button type="button" class="cm-thread" *ngIf="replyCount && !isThread" (click)="openThread.emit()">
        {{ replyCount }} {{ replyCount === 1 ? 'reply' : 'replies' }}
      </button>
    </div>

    <div class="cm-acts" *ngIf="!blocked || canReportUser" role="toolbar" aria-label="Message actions">
      <button type="button" class="emoji-input" (click)="toggleEmoji.emit()" aria-label="Add reaction" title="React">
        <mat-icon class="emoji-input">add_reaction</mat-icon>
      </button>
      <button type="button" *ngIf="!isThread" (click)="openThread.emit()" aria-label="Reply in thread" title="Reply in thread">
        <mat-icon>forum</mat-icon>
      </button>
      <button type="button" *ngIf="canEdit" (click)="startEdit()" aria-label="Edit message" title="Edit">
        <mat-icon>edit</mat-icon>
      </button>
      <ng-container *ngIf="canReportUser || canReportMessage">
        <button type="button" [matMenuTriggerFor]="reportMenu" aria-label="Report" title="Report">
          <mat-icon>flag</mat-icon>
        </button>
        <mat-menu #reportMenu="matMenu" class="cm-menu">
          <button mat-menu-item *ngIf="canReportUser" (click)="reportUser.emit()">Report user</button>
          <button mat-menu-item *ngIf="canReportMessage" (click)="reportMessage.emit()">Report message</button>
        </mat-menu>
      </ng-container>
    </div>
  </div>

  <div class="cm-picker" *ngIf="emojiOpen">
    <emoji-mart [showPreview]="false" [isNative]="true" [set]="'native'" [enableSearch]="false"
      [showSingleCategory]="false" (emojiClick)="pickEmoji.emit($event)"></emoji-mart>
  </div>
</div>
